// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3da6fc5d","239":"a765cc8d","455":"4cb3f228"}[chunkId] + ".chunk.js";
};